<template>
  <div v-if="mainFilter" class="container-fluid pt-8">
    <div class="d-flex align-items-center bg-primary py-7 px-6 mb-5 rounded">
      <div class="mr-3 flex-nowrap">
        <img :src="'/static/img/logo/BUMN.svg'" alt="Logo APP" class="max-h-40px mr-3" />
        <img :src="'/static/img/logo/adhi.svg'" alt="Logo APP" class="max-h-40px mr-3" />
        <img :src="'/static/img/logo/infra-2.svg'" alt="Logo APP" class="max-h-40px mr-3" />
      </div>
      <div class="flex-fill">
        <h3 class="text-light font-weight-bold mb-0">{{ mainFilter.project_list[activeSlide].project_name }}</h3>
        <span class="text-white mt-3 font-weight-bold">
          <span v-if="mainFilter.territory_id.code">Division {{ mainFilter.territory_id.label }},</span>
          <span v-if="mainFilter.is_jo.code">Type {{ mainFilter.is_jo.label }},</span>
          <span v-if="mainFilter.periode_month">{{ mainFilter.periode_month }}</span>
        </span>
      </div>
      <div class=" flex-nowrap">
        <button :disabled="activeSlide === 0" @click="activeSlide--" class="btn btn-lg btn-light btn-icon">
          <span class="svg-icon svg-icon-primary svg-icon-2x">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect x="0" y="0" width="24" height="24" />
                <path d="M11.0879549,18.2771971 L17.8286578,12.3976203 C18.0367595,12.2161036 18.0583109,11.9002555 17.8767943,11.6921539 C17.8622027,11.6754252 17.8465132,11.6596867 17.8298301,11.6450431 L11.0891271,5.72838979 C10.8815919,5.54622572 10.5656782,5.56679309 10.3835141,5.7743283 C10.3034433,5.86555116 10.2592899,5.98278612 10.2592899,6.10416552 L10.2592899,17.9003957 C10.2592899,18.1765381 10.4831475,18.4003957 10.7592899,18.4003957 C10.8801329,18.4003957 10.9968872,18.3566309 11.0879549,18.2771971 Z" fill="#000000" opacity="0.3" transform="translate(14.129645, 12.002277) scale(-1, 1) translate(-14.129645, -12.002277) " />
                <path d="M5.08795487,18.2771971 L11.8286578,12.3976203 C12.0367595,12.2161036 12.0583109,11.9002555 11.8767943,11.6921539 C11.8622027,11.6754252 11.8465132,11.6596867 11.8298301,11.6450431 L5.08912711,5.72838979 C4.8815919,5.54622572 4.56567821,5.56679309 4.38351414,5.7743283 C4.30344325,5.86555116 4.25928988,5.98278612 4.25928988,6.10416552 L4.25928988,17.9003957 C4.25928988,18.1765381 4.48314751,18.4003957 4.75928988,18.4003957 C4.88013293,18.4003957 4.99688719,18.3566309 5.08795487,18.2771971 Z" fill="#000000" transform="translate(8.129645, 12.002277) scale(-1, 1) translate(-8.129645, -12.002277) " />
              </g>
            </svg>
          </span>
        </button>
        <button :disabled="mainFilter.project_list.length === 1" @click="autoplaySlide = !autoplaySlide" class="btn btn-lg btn-light btn-icon mx-2">
          <span v-if="autoplaySlide" class="svg-icon svg-icon-primary svg-icon-2x">
            <!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo3/dist/../src/media/svg/icons/Media/Pause.svg-->
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect x="0" y="0" width="24" height="24" />
                <path d="M8,6 L10,6 C10.5522847,6 11,6.44771525 11,7 L11,17 C11,17.5522847 10.5522847,18 10,18 L8,18 C7.44771525,18 7,17.5522847 7,17 L7,7 C7,6.44771525 7.44771525,6 8,6 Z M14,6 L16,6 C16.5522847,6 17,6.44771525 17,7 L17,17 C17,17.5522847 16.5522847,18 16,18 L14,18 C13.4477153,18 13,17.5522847 13,17 L13,7 C13,6.44771525 13.4477153,6 14,6 Z" fill="#000000" />
              </g>
            </svg>
            <!--end::Svg Icon-->
          </span>
          <span v-else class="svg-icon svg-icon-primary svg-icon-2x">
            <!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo3/dist/../src/media/svg/icons/Media/Play.svg-->
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect x="0" y="0" width="24" height="24" />
                <path d="M9.82866499,18.2771971 L16.5693679,12.3976203 C16.7774696,12.2161036 16.7990211,11.9002555 16.6175044,11.6921539 C16.6029128,11.6754252 16.5872233,11.6596867 16.5705402,11.6450431 L9.82983723,5.72838979 C9.62230202,5.54622572 9.30638833,5.56679309 9.12422426,5.7743283 C9.04415337,5.86555116 9,5.98278612 9,6.10416552 L9,17.9003957 C9,18.1765381 9.22385763,18.4003957 9.5,18.4003957 C9.62084305,18.4003957 9.73759731,18.3566309 9.82866499,18.2771971 Z" fill="#000000" />
              </g>
            </svg>
            <!--end::Svg Icon-->
          </span>
        </button>
        <button :disabled="(activeSlide+1) === mainFilter.project_list.length" @click="activeSlide++" class="btn btn-lg btn-light btn-icon">
          <span class="svg-icon svg-icon-primary svg-icon-2x">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect x="0" y="0" width="24" height="24" />
                <path d="M6.82866499,18.2771971 L13.5693679,12.3976203 C13.7774696,12.2161036 13.7990211,11.9002555 13.6175044,11.6921539 C13.6029128,11.6754252 13.5872233,11.6596867 13.5705402,11.6450431 L6.82983723,5.72838979 C6.62230202,5.54622572 6.30638833,5.56679309 6.12422426,5.7743283 C6.04415337,5.86555116 6,5.98278612 6,6.10416552 L6,17.9003957 C6,18.1765381 6.22385763,18.4003957 6.5,18.4003957 C6.62084305,18.4003957 6.73759731,18.3566309 6.82866499,18.2771971 Z" fill="#000000" opacity="0.3" />
                <path d="M12.828665,18.2771971 L19.5693679,12.3976203 C19.7774696,12.2161036 19.7990211,11.9002555 19.6175044,11.6921539 C19.6029128,11.6754252 19.5872233,11.6596867 19.5705402,11.6450431 L12.8298372,5.72838979 C12.622302,5.54622572 12.3063883,5.56679309 12.1242243,5.7743283 C12.0441534,5.86555116 12,5.98278612 12,6.10416552 L12,17.9003957 C12,18.1765381 12.2238576,18.4003957 12.5,18.4003957 C12.6208431,18.4003957 12.7375973,18.3566309 12.828665,18.2771971 Z" fill="#000000" />
              </g>
            </svg>
          </span>
        </button>
      </div>
    </div>
    <carousel :value="activeSlide" loop :autoplay="autoplaySlide" :autoplayHoverPause="false" :autoplayTimeout="1000 * 60 * 1" centerMode :perPage="1" :paginationPosition="'bottom'" :paginationColor="'var(--white)'" :paginationActiveColor="'var(--primary)'">
      <slide v-for="(f, i) in mainFilter.project_list" :key="i + '-filter'">
        <single-view-pc :filterData="Object.assign({}, mainFilter, { project_id: { label: f.project_name, code: f.id } })" />
      </slide>
    </carousel>
  </div>
</template>

<script>
import singleViewPc from './project-control-single.vue'
import moment from 'moment'
moment.locale('id')
export default {
  name: 'carousel-dashboard',
  components: { singleViewPc },
  data () {
    return {
      mainFilter: null,
      activeSlide: 0,
      autoplaySlide: true
    }
  },
  watch: {
    '$route.query': {
      deep: true,
      immediate: true,
      handler (e) {
        if (e && e.replace) this.buildData(JSON.parse(e.replace))
      }
    }
  },
  methods: {
    buildData (e) {
      this.mainFilter = e
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/dashboard/project-control-carousel.vue